import React from "react";
import {
  List,
  ListItem,
  ListItemPrefix,
  Drawer,
  Card,
} from "@material-tailwind/react";
import {
  PowerIcon,
  ClockIcon,
} from "@heroicons/react/24/solid";
import { images } from "../../constants";
import PropTypes from "prop-types";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";


const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const ToolBar = ({ drawerState, isLogin }) => {
  const notifyError = (message) => toast.error(message,  { className: 'toast-error' });
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const showLanguageToast = (message) => {
    toast.info(message, {
      className: 'toast-info',
      icon: false
    });
  };

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    localStorage.setItem("lang", newLang);
    i18n.changeLanguage(newLang);
    showLanguageToast(t("toast_change_language"));
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      let lang = true;
      if (localStorage.getItem('lang') === 'id') {
        lang = false;
      }

      await axios.put(
        "https://backend2.senarai-app.com/user/language",
        { language_english: lang },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      await axios.post("https://backend2.senarai-app.com/logout");
      localStorage.removeItem('token');
      window.location.href = '/'
    } catch (error) {
      if (error?.response?.data) {
        notifyError(error.response.data.detail);
      } else {
        notifyError(`Error logging out: ${error.message}`);
      }
    }
  }

  return (
    <>
      <Drawer open={drawerState} onClose={() => (drawerState = false)}>
        <Card
          color="transparent"
          shadow={false}
          className="h-[calc(100vh-2rem)] w-full p-4"
        >
          <div className="mt-8 flex items-center gap-4 p-4">
            <div className="">
              <img src={images.senarai} alt="senarai" style={{ height: 32 }} />
            </div>
          </div>
          <List>
            <div className="flex justify-center my-4">
              <select
                value={i18n.language}
                onChange={handleLanguageChange}
                data-testid="toolbar-language-dropdown"
                className="w-fit bg-transparent pl-2 font-lato text-black py-2 border border-gray-400 shadow-md rounded-xl"
              >
                <option value="en" data-testid="en">
                  English
                </option>
                <option value="id" data-testid="id">
                  Indonesia
                </option>
              </select>
            </div>
            {isLogin && (
              <a href="/history">
                <ListItem className="py-2 hover:bg-gray-100" data-testid="toolbar-history">
                  <ListItemPrefix>
                    <ClockIcon className="h-5 w-5 mr-2" />
                  </ListItemPrefix>
                  {t("toolbar_history")}
                </ListItem>
              </a>
            )}
            {isLogin && (
              <ListItem
                className="py-2 hover:bg-gray-100"
                onClick={handleLogout}
                data-testid="toolbar-logout"
              >
                <ListItemPrefix>
                  <PowerIcon className="h-5 w-5 mr-2" />
                </ListItemPrefix>
                {t("toolbar_logout")}
              </ListItem>
            )}
          </List>
        </Card>
      </Drawer>
    </>
  );
};

ToolBar.propTypes = {
  drawerState: PropTypes.bool,
  isLogin: PropTypes.bool,
};

export default ToolBar;
